import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./components/shared/utils/storageMigration";
import "../src/components/shared/i18next"; // Import i18n configuration
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./components/auth/msalConfig"; // Ensure you have this config file set up

const root = ReactDOM.createRoot(document.getElementById("root"));
const clientId_google = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const msalInstance = new PublicClientApplication(msalConfig);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId_google} ux_mode="popup">
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
